import { IProducts } from 'interfaces/imProducts.interface';

const mapVariationToProduct = (products: IProducts[]): IProducts[] => {
  const prods: IProducts[] = [];

  products.map((product) => {
    if (product.type === 'variable') {
      product.variation.map((variation) => {
        prods.push({
          name: variation.name,
          parentId: String(variation.parentId),
          productId: variation.productId,
          quantity: String(variation.stock_quantity),
          sku: variation.sku,
          stock: String(variation.stock),
          type: 'variación',
          unitCost: product.unitCost,
          unitCostNew: product.unitCostNew
        } as IProducts);
      });
    } else {
      prods.push(product);
    }
  });

  return prods;
};

export default mapVariationToProduct;
